import { useInView } from 'react-intersection-observer'
import React, { useEffect } from 'react'

const LazyAction = ({ children, disabled, waiting, action }) => {
  const [wrapperRef, isOnScreen] = useInView({ threshold: 0 })

  useEffect(() => {
    if (!waiting && isOnScreen) action()
    // eslint-disable-next-line
  }, [isOnScreen])
  if (disabled) return false
  return <div ref={wrapperRef}>{children}</div>
}

export default LazyAction
